import { ANALYTICS } from './analytics';
import { APARTMENT_LIST } from './apartmentList';
import { APARTMENT_STATUS } from './apartmentStatus';
import { CALLS } from './calls';
import { DEFECTS } from './defects';
import { DOCUMENTS } from './documents';
import { ENGINEERING } from './engineering';
import { PLACEMENTS_STATUS } from './placementsStatus';
import { PLAN } from './plan';
import { PLAN_ENG_NET_COMMISSIONING } from './planEngNetCommissioning';
import { DELIVERY_SCHEDULE } from './deliverySchedule';
import { SETTING } from './setting';
import { START_SETTLEMENT } from './startSettlement';
import { SYSTEM } from './system';
import { TIMESHEET } from './timesheet';
import { TIMETABLE } from './timetable';
import { UPDATES } from './updates';
import { UPLOADING_PLAN } from './uploadingPlan';

export const ROUTES = {
  ANALYTICS,
  APARTMENT_LIST,
  APARTMENT_STATUS,
  CALLS,
  DEFECTS,
  DOCUMENTS,
  ENGINEERING,
  PLACEMENTS_STATUS,
  PLAN_ENG_NET_COMMISSIONING,
  PLAN,
  DELIVERY_SCHEDULE,
  SETTING,
  START_SETTLEMENT,
  SYSTEM,
  TIMESHEET,
  TIMETABLE,
  UPDATES,
  UPLOADING_PLAN,
};
